<template>
    <div class="wx-open-launch-app-block">
        <div class="slot-wrap">
            <slot></slot>
        </div>
        <wx-open-launch-app
            class="launch-btn"
            :appid="appId"
            :extinfo="extInfo"
            @error="handleErrorFn"
            @launch="handleLaunchFn"
        >
            <script type="text/wxtag-template">
                <div style="padding: 1000px; opacity: 0;"></div>
            </script>
        </wx-open-launch-app>
    </div>
</template>

<script>
export default {
    props: {
        extInfo: {
            type: String,
            default: '',
        },
        launchHandler: {
            type: Function,
            default: () => {},
        },
        errorHandler: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            appId: 'wxb0a1224c62ee23b3', // 快影
        };
    },
    methods: {
        // 监听launch 函数，用户点击跳转按钮并对确认弹窗进行操作后触发
        handleLaunchFn(e) {
            console.log('handleLaunchFn:', e);
            this.$props.launchHandler && this.$props.launchHandler('launch', e);
        },
        // 用户点击跳转按钮后出现错误
        handleErrorFn(e) {
            console.log('handleErrorFn:', e);
            this.$props.errorHandler && this.$props.errorHandler('error', e);
        },
        
    },
    created() {
    }
  }
</script>

<style scoped lang="less">
.wx-open-launch-app-block {
    display: block;
    position: relative;
    overflow: hidden;
    .slot-wrap {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .launch-btn {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
    }
}
</style>
